export default "__VITE_ASSET__Bbt62h_V__"